import { NuqsAdapter } from "nuqs/adapters/react-router/v7";
import { Outlet } from "react-router";

/** Корневой маршрут: адаптер `nuqs` (состояние в URL) поверх всех экранов. */
export function RootLayout() {
    return (
        <NuqsAdapter>
            <Outlet />
        </NuqsAdapter>
    );
}
